import 'bootstrap';

// よくわからんけどいったんこうしている
// 【注意】const.phpの定義と同一にすること
export const CONSTANT_APPROVAL_STATUS = {
    'APPROVAL_STATUS_UNAPPROVAL': 0,
    'APPROVAL_STATUS_APPROVED': 1,
    'APPROVAL_STATUS_REJECT': 2,
    'APPROVAL_STATUS_CANCEL': 3,
};

export const CONSTANT_DELIVERY_STATUS = {
    'DELIVERY_STATUS_READY': 0,
    'DELIVERY_STATUS_APPROVED_WAIT': 1,
    'DELIVERY_STATUS_APPROVED_OK': 2,
    'DELIVERY_STATUS_APPROVED_NG': 3,
    'DELIVERY_STATUS_RUNNING': 4,
    'DELIVERY_STATUS_RECEIVED': 5,
    'DELIVERY_STATUS_CONSUMPTION': 6,
    'DELIVERY_STATUS_CANCEL': 7,
};

export const CONSTANT_CASE_CUBIC_MULTIPLICATION = " × ";

//************************************************************************************************* */
// JMAP共通設定
// https://yugokimura.github.io/jmap/
//************************************************************************************************* */
export const JMAP_COMMON_SETTING = {
    height: "550px",
    skew: '10',
    showHeatmap: true,
    showHeatlabel: true,
    prefectureLineColor : '#CCCCCC',
    prefectureLineWidth : '1px',
};
// 拠点設定
export const JMAP_LOGIHUB_CONDITIONS = [" == 0", "< 5", " >= 5", ">= 10", ">= 15", ">= 20", ">= 25", ">= 30", ">= 35", ">= 40" ];
// export const JMAP_LOGIHUB_COLORS =  ["#b2b2b2", "#c7e5e8", "#C9B2CD", "#BCE3DE", "#BBCDDE", "#9BB5BA", "#A3C4A4", "#E6E26A", "#E1A25E", "#BC5050"];
export const JMAP_LOGIHUB_HTYPE =  'YlGnBu';
export const JMAP_LOGIHUB_UNIT =  '拠点';
// 物流（配送）設定
export const JMAP_LOGISTICS_CONDITIONS = [" == 0", "< 2", " >= 2", ">=4", ">= 6", ">= 8", ">= 10", ">= 12", ">= 14", ">= 16" ];
// export const JMAP_LOGISTICS_COLORS =   ["#b2b2b2", "#F0FEEE", "#C9B2CD", "#BCE3DE", "#BBCDDE", "#9BB5BA", "#A3C4A4", "#E6E26A", "#E1A25E", "#BC5050"];
export const JMAP_LOGISTICS_HTYPE =  'YlGn';
export const JMAP_LOGISTICS_UNIT =  'ヶ所';
